import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import EmailService from '../../services/EmailService';

const EmailCreate = () => {
  const [recipient_name, setRecipientName] = useState('');
  const [recipient_email, setRecipientEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await EmailService.create({ recipient_name, recipient_email });
      Swal.fire('Success!', 'Email added successfully.', 'success');
      navigate('/emails');
    } catch (error) {
      console.error('Error creating email:', error);
      Swal.fire('Error!', 'Failed to add email. Please try again.', 'error');
    }
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Add New Email</h4>
              <p className="card-description">Enter recipient details</p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Recipient Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={recipient_name}
                    onChange={(e) => setRecipientName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Recipient Email</label>
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    value={recipient_email}
                    onChange={(e) => setRecipientEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-sm">Save</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailCreate;
